import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { catchErrorLogRet } from '../common/rest.operators';

import { LgConfig, LgConfigView, LgUserConfig } from './core';
import {
    ExtMenuItem,
    NavItem,
    NavLoader,
    NavModelTransformer,
} from './nav.model';

@Injectable()
export class NavService {
    nav: NavItem[];
    private _nav: NavLoader;

    constructor(
        private readonly _http: HttpClient,
        private readonly _router: Router,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    list(userId: number, forceReload?: boolean): Observable<NavItem[]> {
        if (!forceReload && !!this.nav) {
            return of(this.nav);
        }

        return this._http
            .get<ExtMenuItem[]>(
                `${this._appConfig.API_ENDPOINTS.USER}/navigation/users/${userId}`,
            )
            .pipe(
                map((model) => {
                    this.nav = new NavModelTransformer(this._router).transform(
                        model,
                    );
                    return this.nav;
                }),
                catchError((error) => {
                    console.error(error);
                    return of([]);
                }),
            );
    }

    upsertLandingConfig(config: LgConfig): Observable<void> {
        return this._http
            .post<LgConfig | null>(
                `${this._appConfig.API_ENDPOINTS.USER}/navigation/landing/config`,
                config,
            )
            .pipe(catchErrorLogRet(null));
    }

    retrieveLandingConfig(): Observable<LgConfigView | null> {
        return this._http
            .get<LgConfig | null>(
                `${this._appConfig.API_ENDPOINTS.USER}/navigation/landing/config`,
            )
            .pipe(catchErrorLogRet(null));
    }

    retrieveLandingUserConfig(userId: number): Observable<LgUserConfig | null> {
        const params = new HttpParams().set('userId', String(userId));
        return this._http
            .get<LgUserConfig | null>(
                `${this._appConfig.API_ENDPOINTS.USER}/navigation/landing/user-config`,
                { params },
            )
            .pipe(catchErrorLogRet(null));
    }

    reset(): void {
        this.nav = null;
    }

    register(nav: NavLoader): void {
        this._nav = nav;
    }

    reload(forceReload: boolean): Observable<any> {
        if (!this._nav) return;
        this._nav.loadPhoto().subscribe(null, () => null);
        return this._nav.load(forceReload);
    }
}
